<template>
    <!-- 兑换课程 -->
    <div class="change-page">
        <navBar title="课程列表" @onClickLeft="handleBack"/>
        <div class="banner"></div>
        <div class="list">
            <div class="item" v-for="(item,index) in courseList" :key="item.id">
                <img class="img" :src="`${item.picUrl}?x-oss-process=image/format,jpg/resize,m_pad,w_240,h_180`" alt="">
                <div class="info">
                    <div class="title van-multi-ellipsis--l2"><span v-if="tagList[index]" class="tag">{{tagList[index]}}</span>{{item.name}}</div>
                    <div class="handle-box">
                        <div class="price-box">
                            <p class="price">折后价：<span>¥ 0</span></p>
                            <p class="old-price">原价：¥{{item.salePrice}}</p>
                        </div>
                        <div class="change-btn" 
                            :class="{'disable':changeType && !item.changeStatus}" 
                            @click="handleDetail(item, changeType && !item.changeStatus)"
                        >
                            {{item.changeStatus?'查看':'一键兑换'}}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import api from "../../../api";
    import navBar from '../components/navBar.vue';
    import { tagList } from '../config/enum';

    const cardPath ={
        1: '/dream',
        2: '/flaunt'
    }
    export default {
        async beforeRouteEnter(to, from, next) {
            const isLogin = localStorage.getItem('token');
            
            if(isLogin) {
                const {success, data} = await api.entityCard.checkBindStatus();
                if(success) {
                    if(!data) {
                        next({
                            path: '/entityCard/binding'
                        });
                        return;
                    }
                    return next((vm)=>{
                        vm.cardType = data.id;
                    });
                }
            }
            next({
                path: '/entityCard/binding'
            });
        },
        components: {
            navBar,
        },
        data() {
            return {
                tagList,
                changeLen: 0, // 可兑换数量 1集结卡 2未来卡
                changeType: false,
                courseList: [],
                changeList: [],
                cardType: '',
            }
        },
        created () {
            this.onGetData();
            this.onCheckBindStatus();
        }, 
        methods: {
            onGetData() {
                this.$api.entityCard.getCourseList().then(({success,data})=>{
                    if(success) {
                        data.forEach(item=>{item.changeStatus = false})
                        this.onGetChangeList(data);
                    }
                })
            },
            onCheckBindStatus() {
                this.$api.entityCard.checkBindStatus({}).then(({success, data})=>{
                    if(success && data) {
                        this.changeLen = data.id == 1 ? 1: 2;
                    }
                })
            },
            onGetChangeList(courseList) {
                this.$api.entityCard.getChangeList().then(({success, data})=>{
                    if(success && data) {
                        this.changeList = data || [];
                        courseList.forEach(item => {
                            if(this.changeList.includes(item.id)) {
                                item.changeStatus = true
                            }
                        });
                        this.courseList = courseList;
                        this.changeType = this.changeLen <= this.changeList.length;
                    }
                })
            },
            handleDetail({id},status) {
                if(status) {
                    return false
                }
                window.location.href = `/goodsDetail?goodsId=${id}&goodsKind=1&isH5=1`;
            },
            handleBack() {
                this.$router.go(-1)
            }
        },
    }
</script>

<style lang="less" scoped>
    .change-page {
        min-height: 100vh;
        background-color: #DBF1FF;
        padding-bottom: 40px;
        .banner {
            height: 616px;
            margin-bottom: 25px;
            background: url('../asset/images/card_banner.jpg') no-repeat center center /100% 100%;
        }
        .list {
            padding: 0 16px;
            .item {
                padding: 20px 16px;
                background-color: #fff;
                display: flex;
                justify-content: space-between;
                border-radius: 16px;
                margin-bottom: 25px;
                .img {
                    width: 240px;
                    height: 180px;
                    margin-right: 24px;
                    border-radius: 24px;
                }
                .info {
                    flex: 1;
                    display: flex;
                    justify-content: space-between;
                    flex-direction: column;
                    .title {
                        height: 92px;
                        overflow: hidden;
                        font-size: 30px;
                        font-family: PingFangSC-Medium, PingFang SC;
                        font-weight: 500;
                        color: #333333;
                        line-height: 46px;
                        word-break: break-all;
                        span {
                            min-width: 66px;
                            height: 36px;
                            background: rgba(31,148,255,0.18);
                            border-radius: 4px;
                            font-size: 20px;
                            font-weight: 400;
                            color: #1F94FF;
                            line-height: 36px;
                            display: inline-block;
                            text-align: center;
                            margin-right: 13px;
                            position: relative;
                            top: -3px;
                        }
                    }
                    .handle-box {
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        .price-box {
                            flex: 1;

                            .price {
                                font-size: 26px;
                                font-family: PingFangSC-Semibold, PingFang SC;
                                font-weight: 600;
                                color: #FE5746;
                                line-height: 37px;
                                display: flex;
                                align-items: center;
                                margin-bottom: 6px;
                                span {
                                    font-size: 32px;
                                    font-family: AvenirNext-DemiBold, AvenirNext;
                                    line-height: 32px;
                                }
                            }
                            .old-price {
                                font-size: 22px;
                                font-family: PingFangSC-Regular, PingFang SC;
                                font-weight: 400;
                                color: #999999;
                                line-height: 24px;
                                text-decoration: line-through;
                                
                            }
                        }
                        .change-btn {
                            margin-left: 5px;
                            width: 168px;
                            text-align: center;
                            background-color: #568EFF;
                            border-radius: 32px;
                            font-size: 26px;
                            font-weight: 400;
                            color: #FFFFFF;
                            line-height: 64px;
                            &.disable {
                                background: #D8D8D8;
                            }
                        }
                    }
                }
            }
        }
    }
</style>